export default {"src":"/_next/static/media/Github_Icon.1b50c59a.svg","height":75,"width":79,"blurWidth":0,"blurHeight":0};